import request from './request';
export function getRankList(params) {
  return request.get('/api/rank/rankList', { params });
}
export function getMyRank(params) {
  return request.get('/api/rank/myRank', { params });
}
